import { observable } from 'mobx';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { Subscription } from '../../../types/subscriptions';
import { SubscriptionsApis } from '../../../apis/subscriptions';

export class SubscriptionSuspensionConfirmationPageState {
    @observable subscriptionCode: string;
    @observable subscription: RemoteResourceV3<Subscription> = RemoteResourceV3.loading();
    @observable initialized = false;
    @observable routerState = GlobalStatesV3.routing;

    async init(code: string) {
        this.initialized = false;
        this.subscriptionCode = code;
        await updateRemoteResourceV3(
            this.subscription,
            (v) => (this.subscription = v),
            () => SubscriptionsApis.show(code)
        );
        this.initialized = true;
    }
}
